<app-header
  #header
  *ngIf="token$ | async"
  class="w-screen"
  (showSideMenu)="isSidebarVisible = true"
/>

<ng-container *ngIf="token$ | async">
  <app-side-menu
    style="position: fixed; top: 55px; z-index: 9"
    class="flex-none hidden md:block"
  />

  <p-sidebar [(visible)]="isSidebarVisible" [style]="{ width: '287px' }">
    <app-side-menu
      style="position: fixed; top: 55px; left: 0"
      class="flex-none"
      (itemClick)="isSidebarVisible = false"
    />
  </p-sidebar>
</ng-container>

<div
  [ngClass]="{
    'p-4': token$ | async,
    'main-content': token$ | async
  }"
  class="flex-grow-1"
>
  <div *ngIf="token$ | async">
    <app-breadcrumb />
  </div>
  <router-outlet />
</div>

<app-footer #footer *ngIf="token$ | async" class="p-fixed w-screen" />

<p-toast>
  <ng-template let-message pTemplate="message">
    <p innerHtml="{{ message.detail }}"></p>
  </ng-template>
</p-toast>

<p-confirmDialog key="def" [style]="{ width: '700px' }" />
<app-user-change-password-form #pwdDialog />
